import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
import { Grid as GridComponent, Box } from 'legion-ui';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Usage`}</h2>
    <p>{`CSS grid layout component to arrange direct child elements in a tiled grid layout.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Grid } from 'legion-ui';
`}</code></pre>
    <div className="divi" />
    <h2>{`Variant`}</h2>
    <p>{`Legion have only one variant of grid`}</p>
    <h3><strong parentName="h3">{`Basic`}</strong></h3>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC"
    }}>
  <GridComponent gap={2} columns={2} mdxType="GridComponent">
    <Box p={2} bg="primary500" color="white" mdxType="Box">
      Box
    </Box>
    <Box p={2} bg="success500" color="white" mdxType="Box">
      Box
    </Box>
    <Box p={2} bg="error500" color="white" mdxType="Box">
      Box
    </Box>
    <Box p={2} bg="tertiary500" color="white" mdxType="Box">
      Box
    </Box>
  </GridComponent>
    </div>
    <div style={{
      "padding": "2rem",
      "backgroundColor": "#F6F7FC"
    }}>
  <GridComponent gap={4} columns="1fr 2fr" mdxType="GridComponent">
    <Box p={2} bg="primary500" color="white" mdxType="Box">
      Box
    </Box>
    <Box p={2} bg="success500" color="white" mdxType="Box">
      Box
    </Box>
    <Box p={2} bg="error500" color="white" mdxType="Box">
      Box
    </Box>
    <Box p={2} bg="tertiary500" color="white" mdxType="Box">
      Box
    </Box>
  </GridComponent>
    </div>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`    <Grid gap={2} columns={2}>
        <Box p={2} bg="primary500" color="white">
            Box
        </Box>
        <Box p={2} bg="success500" color="white">
            Box
        </Box>
        <Box p={2} bg="error500" color="white">
            Box
        </Box>
        <Box p={2} bg="tertiary500" color="white">
            Box
        </Box>
    </Grid>

    <Grid gap={4} columns="1fr 2fr">
        <Box p={2} bg="primary500" color="white">
            Box
        </Box>
        <Box p={2} bg="success500" color="white">
            Box
        </Box>
        <Box p={2} bg="error500" color="white">
            Box
        </Box>
        <Box p={2} bg="tertiary500" color="white">
            Box
        </Box>
    </Grid>
`}</code></pre>
    <div className="divi" />
    <h2>{`Props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`columns?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string `}{`|`}{` number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Number of (equally-sized) columns, or string with grid syntax for the layout (cannot be used in conjunction with the width prop)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`gap?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string `}{`|`}{` number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Space between child elements`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`width?`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string `}{`|`}{` number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Minimum width of child elements`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      